import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IntegracaoService } from 'src/app/service/integracao.service';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { MensagemService } from 'src/app/service/mensagem.service';
import { CacheService } from 'src/app/service/cache.service';
import { Helper } from 'src/app/shared/Helper';
import { LeedService } from 'src/app/service/leed.service';

@Component({
  selector: 'app-home-cliente',
  templateUrl: './home-cliente.component.html',
  styleUrls: ['./home-cliente.component.css']
})
export class HomeClienteComponent implements OnInit {

  public planilha: any;
  public percentDone: number;
  public enviando: boolean;
  public processando: boolean;
  public importando: boolean;
  public totalNovosLeeds = 0;

  constructor(private router: Router,
    private integracaoService: IntegracaoService,
    private msg: MensagemService,
    private cacheService: CacheService,
    private leedService: LeedService) { }

  ngOnInit() {
    Helper.RefreshSlider();
    if (this.exibeTabLeeds) {
      this.carregarTotalNovosLeeds();
    }
  }

  get exibeTabLeeds(): boolean {
    return Helper.getIsDistribuidor();
  }

  public NovoPedido() {
    this.processando = true;
    this.cacheService.GetCache().subscribe(cp => {
      if (cp && cp.itens && cp.itens.length) {
        const that = this;
        this.msg.ConfirmDialog('Continuar pedido', 'Existe um pedido iniciado e não concluido. Deseja continuar a digitação de onde parou?', function (result) {
          if (result) {
            that.cacheService.Cache = cp;
          }
          that.router.navigate(['/pedido']);
        });

      }
      else {
        this.router.navigate(['/pedido']);
      }
    });

  }

  public ImportarPlanilhaPedido() {
    if (this.planilha) {
      this.UploadPlanilha();
    }
    else {
      this.msg.Error('Para importar, primeiro é nescessário selecionar uma planilha!');
    }
  }

  public onSelectImportPlanilha(event: EventTarget) {
    const eventObj: MSInputMethodContext = <MSInputMethodContext>event;
    const target: HTMLInputElement = <HTMLInputElement>eventObj.target;
    const files: FileList = target.files;
    if (files.length) {
      const file = files[0];
      if (file) {
        const formData = new FormData();
        formData.append(file.name, file);
        this.planilha = formData;
      }
    }
  }

  public UploadPlanilha() {
    if (this.planilha) {
      this.enviando = true;
      this.importando = true;
      this.integracaoService.UploadPlanilha(this.planilha).subscribe(event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.percentDone = Math.round(100 * event.loaded / event.total);
        }
        else if (event instanceof HttpResponse) {
          if (!event.body.msg) {
            this.integracaoService.GetCachePlanilha().subscribe(cp => {
              this.integracaoService.cachePlanilha = cp;
              this.msg.Sucesso('Pedido importado com sucesso!');
              this.router.navigate(['/pedido']);
            });
          }
          else {
            this.msg.Error(event.body.msg);
            this.enviando = false;
            this.importando = false;
          }
        }

      }, () => {
        this.enviando = false;
        this.importando = false;
      });
    }
  }

  public ConsultarPedido() {
    this.router.navigate(['/consulta']);
  }

  private carregarTotalNovosLeeds() {
    this.leedService.getDashboardLeads('', '').subscribe(response => {
      if (response && response.sucesso && response.totais) {
        this.totalNovosLeeds = response.totais.novosLeads || 0;
      }
    });
  }

}
